<section class="vehicle-management-wrapper">
    
    <section class="row-header">
        <div class="header d-flex" *ngIf="!unavailableVehicleWindow">
            <div class="title">
              {{'vehicleManagement.testDriveVehicleList' | translate }}
              <div class="warning-msg" *ngIf="(pendingAppointmentCount$ | async) > 0">
                <div><span class="material-icons" >info</span></div>
                <div>{{'testDrive.pleaseCheckTheUpcomingTestDriveAppointmentsWithUnavailableVehicles' | translate }}</div>
            </div>
          </div>
          <div class='actions' *ngIf="!isLmex ? (viewMode === source.ME) : true" [matTooltip]="(isLmex && !isCrmIntegrated ? 'otherTexts.notSubscribedToCrmIntegration' : '') | translate"
          matTooltipClass="asp-custom-tooltip" matTooltipPosition="above">
              <div (click)="addNewVehicle()" class='action' [ngStyle]="{'background-color': isLmex ? 'white' : 'var(--primary-toyota-color)', 'border': isLmex ? '1px solid black' : 'none'}" 
              [ngClass]="( isLmex && ((isCrmIntegrated && (syncStatus$ | async) && (syncStatus$ | async)?.status === 'SYNC_IN_PROGRESS') || !isCrmIntegrated)) ? '' : 'enabled'">
                  <div *ngIf="!isLmex" class="box">
                      <div class="plus">+</div>
                  </div>
                  <ng-container *ngIf="isLmex && (syncStatus$ | async)?.status === 'SYNC_IN_PROGRESS'; else vehicleActionLabel">
                    <app-loading loadingSymbol="dots" [text]="'servicePersonnel.syncInProgress' | translate" color="var(--primary-toyota-color)" size=".55" [compact]="true"></app-loading>
                  </ng-container>
                  <ng-template #vehicleActionLabel>
                    <div *ngIf="isLmex">
                      <asp-icon class="icon d-inline-block" name="ic-20-utility-update-small.svg" color='var(--primary-toyota-color)' width="1.2rem" height='1.2rem'></asp-icon>
                    </div>
                    <div class="btnText" [ngStyle]="{'color': isLmex ? 'black' : 'white'}" >{{ isLmex ? ('vehicleManagement.syncFromCrm' | translate ) : ('vehicleManagement.addNewVehicle' | translate) }}</div>
                  </ng-template>
              </div>
              <div *ngIf="isLmex && isCrmIntegrated && (syncStatus$ | async) && (syncStatus$ | async)?.lastSyncedAt" class="sync-text">
                <asp-icon class="icon d-inline-block" name="ic-20-utility-time-clock.svg" width="1.2rem" height='1.2rem'
                  color='var(--primary-toyota-color)'>
                </asp-icon>
                <span class="sync-icon-text">{{(syncStatus$ | async) && (syncStatus$ | async)?.lastSyncedAt ? (syncStatus$ | async)?.lastSyncedAt : '' }}</span>
              </div>
          </div>
        </div>
        
          
        <div *ngIf="searchValues.length > 0" class="search-group d-flex">
          <div class="d-flex filter-group">
            <div *ngFor="let search of searchValues, let i = index">
              <div class="filter-value d-flex" *ngIf="search.colValue">
                <div class="filter-text">
        
                  <span>{{search.colValue | translate}}</span>
        
                </div>
        
                <div class="icon" style="top: 0.3rem;" (click)="onCloseFilterValue(search.column, i)">
                  <mat-icon style="height: 25px;">clear</mat-icon>
                </div>
        
              </div>
            </div>
          </div>
          <div class="d-flex" style="width: 3%">
            <div (click)="clearFilters()" class='action enabled clear-btn-style'>
              <div class="btnText clear-btn-text">{{ 'servicePersonnel.clear' | translate }}</div>
            </div>
          </div>
        </div>
        <div class='multi-view-options' *ngIf="!unavailableVehicleWindow">
          <div class='multi-view' *ngIf="!isLmex" [ngClass]="viewMode === source.NVI ? 'selected':''"
              (click)="loadView(source.NVI)">{{'pendingAppointments.new'| translate}}</div>
          <div class='multi-view' *ngIf="!isLmex"  [ngClass]="viewMode === source.UVI ? 'selected':''"
              (click)="loadView(source.UVI)">{{(isLexus ? 'otherTexts.preOwned' : 'pendingAppointments.used') | translate}}
          </div>
          <div class='multi-view' [ngClass]="viewMode === source.ME ? 'selected':''"
              (click)="loadView(source.ME)">{{(isLmex ? 'CRM' : 'opcodeServiceManagement.other') | translate}}
          </div>
          <div class='multi-view d-flex' style="justify-content: center;"[ngClass]="viewMode === 'Delete Pending' ? 'selected':''"
              (click)="loadView('Delete Pending')"><div class="material-icons" *ngIf="(pendingAppointmentCount$ | async) > 0">info</div>
              <div>{{'testDrive.unavailableVehicles'| translate}}
              <span *ngIf="(pendingAppointmentCount$ | async) > 0"> ({{pendingAppointmentCount$ | async }})</span></div>
          </div>
      </div>
       
      </section>
      <div *ngIf="viewMode !== 'Delete Pending'">

      <section *ngIf="!(isLoading$ | async); else loader">
    <div class="no-vehicle"
    *ngIf="!(vehicles?.length > 0) && searchValues.length === 0 && !isSearchLoading">
        <mat-icon class="mat-icon no-vehicle-info">info_outline</mat-icon>
        <span
          class="label">{{ (viewMode === source.ME ? (isLmex ? 'vehicleManagement.noVehicleInfoMsgForSync' : 'vehicleManagement.noVehicleInfoMsg') : 
          (viewMode === source.UVI ? ('vehicleManagement.thereAreNoEligibleForTestDriveVehiclesInYourUsedVehicleInventory') :('vehicleManagement.thereAreNoEligibleForTestDriveVehiclesInYourNewVehicleInventory') )) | translate}}</span>
      </div>
    <div [hidden]="!(vehicles?.length > 0) && searchValues.length === 0 && !isSearchLoading">
    <div class="panel-left" tabindex="0" [ngClass]="searchValues.length > 0 ? 'withSearch' : ''">
    <div style="width: 75%">
      <div class="sub-header"  style="width: 98.5%;padding-bottom:0.5rem;white-space:nowrap">
        <div style="width: 67%">
          <mat-checkbox disableRipple (change)="onExpandedViewChecked()" [checked]="allRowsExpanded">
            {{ 'vehicleManagement.showExpandedView' | translate }}</mat-checkbox>
        </div>

        <div class="showCount" *ngIf="!unavailableVehicleWindow">
          <span>
            {{'vehicleManagement.totalVehicles' | translate}}: {{showCount.totalVehicles}}
          </span>
          <span style="margin-left: 2rem;">
            {{'vehicleManagement.onlineVehicles' | translate}}: {{showCount.onlineVehicles}}
          </span>
          <span style="margin-left: 2rem;">
            {{'vehicleManagement.offlineVehicles' | translate}}: {{showCount.offlineVehicles}}
          </span>
        </div>

        <div class="bulk-status-controls" *ngIf="viewMode !== 'Delete Pending'">
          <div class="bulk-status-btn-row">
            <div class="delete-btn bulk-status-btn">
              <div (click)="onBulkStatusChange(true)" class='action delete-btn-style bulk-status-action'
                [ngClass]="isBulkStatusBtnEnable(true) && !(isBulkStatusLoading$ | async) ? 'enabled' : ''">
                  <ng-container *ngIf="(isBulkStatusLoading$ | async) && bulkStatusInProgress === true; else onlineLabel">
                    <app-loading loadingSymbol="dots" [text]="''" size=".6" color="white" [compact]="true"></app-loading>
                  </ng-container>
                  <ng-template #onlineLabel>
                    <div class="btnText delete-btn-text bulk-status-btn-text">{{ 'vehicleManagement.onlineVehicles' | translate }}</div>
                  </ng-template>
              </div>
            </div>

            <div class="delete-btn bulk-status-btn">
              <div (click)="onBulkStatusChange(false)" class='action delete-btn-style bulk-status-action'
                [ngClass]="isBulkStatusBtnEnable(false) && !(isBulkStatusLoading$ | async) ? 'enabled' : ''">
                  <ng-container *ngIf="(isBulkStatusLoading$ | async) && bulkStatusInProgress === false; else offlineLabel">
                    <app-loading loadingSymbol="dots" [text]="''" size=".6" color="white" [compact]="true"></app-loading>
                  </ng-container>
                  <ng-template #offlineLabel>
                    <div class="btnText delete-btn-text bulk-status-btn-text">{{ 'vehicleManagement.offlineVehicles' | translate }}</div>
                  </ng-template>
              </div>
            </div>
          </div>

          <div class="bulk-status-warning" *ngIf="shouldShowBulkStatusLimitWarning()">
            {{ 'vehicleManagement.bulkStatusLimitWarning' | translate }}
          </div>
        </div>

        <div class="mr-3 delete-btn">
        <div  (click)="onDeleteSelected()" class='action delete-btn-style' *ngIf="!isLmex && viewMode === source.ME" 
         [ngClass]="isDeleteBtnEnable() ? 'enabled' : ''">
            <div style="margin-top: -6px;">
              <asp-icon name="ic-20-utility-delete-trash.svg" width="1rem" color="white">
    </asp-icon>
            </div>
            <div class="btnText delete-btn-text" >{{ 'vehicleManagement.deleteSelected' | translate }}</div>
        </div>
    </div>

    <div class="delete-btn">
      <div  (click)="onRestoreSelected()" class='action delete-btn-style' *ngIf="!isLmex && viewMode === source.ME" 
       [ngClass]="isRestoreBtnEnable() ? 'enabled' : ''">
          <div class="btnText delete-btn-text" style="left: 0;" >{{ 'vehicleManagement.restoreVehicles' | translate }}</div>
      </div>
  </div>

    </div>
    <div class="table-responsive vehicle-fleet" [ngClass]="searchValues.length > 0 ? 'withSearch' : ''">
      <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="vehicle-tbl">
        <caption style="display: none;"> </caption>
        <ng-container matColumnDef="expand">
          <th mat-header-cell *matHeaderCellDef aria-label="row actions" class="expand outerTbl-cell for-status" 
           scope="col">
            <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selectedVehicles.length > 0 && isAllSelected()"
              [indeterminate] = "(selectedVehicles.length > 0) && (!isAllSelected())"
               style="padding-right: 0.2rem;">
            </mat-checkbox>

            <span class="all">{{'opcodeServiceManagement.all' | translate}}</span>
          </th>
          <td mat-cell *matCellDef="let element" style="border-right: none !important" class="outerTbl-cell for-status">

          <span *ngIf="element.value.length > 1">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? toggleSelectedVehicle(element.value) : null"
              [checked]="isVehicleSelected(element.value)"
              [indeterminate] = " isVehicleSelected(element.value, true)">
            </mat-checkbox>
          </span>

          <span *ngIf="element.value.length === 1">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? toggleSelectedVehicle(element.value[0]) : null"
              [checked]="isVehicleSelected(element.value[0])"></mat-checkbox>
          </span>
          
             <button mat-icon-button aria-label="expand row" *ngIf="element.value.length > 1" style="height: 50%; width: 50%; padding: 2px;"
              (click)="!allRowsExpanded ? toggleRow(element.value[0]) : ''">
              <mat-icon *ngIf="isExpanded(element.value[0]) === 'collapsed'">keyboard_arrow_down</mat-icon>
              <mat-icon *ngIf="isExpanded(element.value[0]) === 'expanded'">keyboard_arrow_up</mat-icon>
            </button>
          </td>
        </ng-container>
    
       <ng-container matColumnDef="{{column.id}}" *ngFor="let column of initColumns">
          <th mat-header-cell class="outerTbl-cell for-status" *matHeaderCellDef scope="col"
          >{{column.display | translate}} </th>
          <td  mat-cell *matCellDef="let element" class="outerTbl-cell for-status" >

            <span *ngIf="column.id === 'model'">
              <img [src]="getImage(element.value[0])"
              (error)="setDefaultImg($event,'images/Sedan_Generic_base_default_34_f_d_490x280.png')"
              alt="Vehicle image">
              &nbsp;
              <span [title]="parsedText(element.value.length === 1 ?  (element.value[0]?.marketingName ? element.value[0].marketingName : element.value[0][column.id]) : element.value[0][column.id])"
              [innerHtml]="element.value.length === 1 ?  (element.value[0]?.marketingName ? element.value[0].marketingName : element.value[0][column.id]) : element.value[0][column.id] "></span>
            </span>

            <span *ngIf="column.id !== 'model' && column.id !== 'make' && column.id !== 'status' && column.id!== 'healthStatus' 
            && column.id!=='vin' && column.id !== 'licensePlate' && column.id !== 'sourceSystem' && column.id !== 'nextTestDriveDate'"
            [title]="element.value.length < 2 ? (column.id === 'odometer' ? (element.value[0][column.id] ? element.value[0][column.id] : 'NA') : element.value[0][column.id] ) : ''">
              {{element.value.length < 2 ? (column.id === 'odometer' ? (element.value[0][column.id] ? element.value[0][column.id] : 'NA') : element.value[0][column.id] ) : '' }}</span>

                <span *ngIf="column.id === 'make'" [title]="element.value[0][column.id]" >{{element.value[0][column.id]}} </span>
                <span *ngIf="column.id === 'nextTestDriveDate' && element.value.length < 2" [title]="getFormattedDate(element.value[0][column.id])">{{getFormattedDate(element.value[0][column.id])}}</span>
                  <span class="copy-vin" *ngIf="column.id === 'vin' && element.value.length < 2" >
                    <div [title]="element.value[0].vin" style="width: 70%;">...{{element.value[0].vin.slice(-7)}}</div>
                    <button mat-icon-button 
                      aria-label="icon-button with a menu" class="copy-icon" matTooltipPosition="above"
                      [matTooltip]="'vehicleManagement.copyVin' | translate" (click)="onCopyDetails(element.value[0].vin)">
                      <mat-icon>
                        <span class="material-icons">content_copy</span>
                      </mat-icon>
                    </button>
                  </span>

                  <span class="licensePlate" *ngIf="column.id === 'licensePlate' && element.value.length < 2">
                    <span [title]="element.value[0][column.id]">{{viewMode === source.ME ? element.value[0][column.id] : element.value[0]['stockNo']}}</span>
                    <div class="licensePlate-right" *ngIf="column.id === 'licensePlate' && viewMode === source.ME" (click) ="mouseEnter(element.value[0]) " 
                    matTooltipPosition="above" [matTooltip]="'testDrive.editStockNo' | translate">
                      <asp-icon color="element.value.length === 1 && selectedVehicle?.vin === element.value[0].vin ? 
                      'white' : 'rgba(14,19,25,0.8)' " height='0.8rem' name="ic-20-utility-edit.svg" width="0.8rem" style="padding-right: 0.5rem"></asp-icon>
                    </div>
                  </span>

                  <span *ngIf="column.id === 'status' && element.value.length < 2">
                    <span *ngIf="element.value[0][column.id] && !element.value[0].expiredAt" class="status online"></span>
                    <span *ngIf="element.value[0][column.id] && !element.value[0].expiredAt" class="text" [title]="'servicePersonnel.online' | translate">{{ 'servicePersonnel.online' | translate}}</span>
                    <span *ngIf="!element.value[0][column.id] && !element.value[0].expiredAt" class="status offline"> </span>
                    <span *ngIf="!element.value[0][column.id] && !element.value[0].expiredAt" class="text" [title]="'vehicleManagement.offline' | translate">{{ 'vehicleManagement.offline' | translate}}</span>
                    <span *ngIf="element.value[0].expiredAt && element.value[0].nextTestDriveDate" class="status deletePending"></span>
                    <span *ngIf="element.value[0].expiredAt && element.value[0].nextTestDriveDate" class="text" [title]="'vehicleManagement.deletePending' | translate">{{'vehicleManagement.deletePending' | translate}}</span>
                  </span>

          </td>
        </ng-container>
    
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length"
            style="width: 100%; padding: 0px; height: 0rem;" class="expanded-detail">
            <div class="example-element-detail" *ngIf="element.value.length > 1"
              [@detailExpand]="isExpanded(element.value[0])">
              <div class="inner-table full-width" *ngIf="isExpanded(element.value[0]) === 'expanded'">
                <table mat-table [dataSource]="element.value" class="inner-tbl">
                  <caption style="display: none;"> </caption>
                  <th style="display: none;"></th>

                  <ng-container matColumnDef="expand" >
                    <td  mat-cell *matCellDef="let element1" class="innerTable-cell"
                     style="border-right: none !important">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? toggleSelectedVehicle(element1) : null"
                      [checked]="isVehicleSelected(element1)">
                    </mat-checkbox>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="{{innerColumn.id}}" *ngFor="let innerColumn of initColumns">
                    <td mat-cell *matCellDef="let element1" class="innerTable-cell" >

                      <span *ngIf="innerColumn.id === 'model'"  class="model-margin"><img [src]="getImage(element1)"
                          (error)="setDefaultImg($event,'images/Sedan_Generic_base_default_34_f_d_490x280.png')"
                          alt="Vehicle image">
                          <span [innerHtml]="element1?.marketingName ? element1.marketingName : element1[innerColumn.id]"
                          [title]="parsedText(element1?.marketingName ? element1.marketingName : element1[innerColumn.id])"> </span>
                       </span>
                          
                      <span *ngIf="innerColumn.id !== 'licensePlate' && innerColumn.id !== 'status' && innerColumn.id !== 'healthStatus' && innerColumn.id !== 'vin' && innerColumn.id !== 'model' && innerColumn.id !== 'sourceSystem'
                      && innerColumn.id !== 'nextTestDriveDate'"
                      [title]="innerColumn.id === 'odometer' ?(element1[innerColumn.id] ? element1[innerColumn.id] : 'NA' ) : element1[innerColumn.id]">
                        {{innerColumn.id === 'odometer' ?(element1[innerColumn.id] ? element1[innerColumn.id] : 'NA' ) : element1[innerColumn.id]}}</span>

                <span *ngIf="innerColumn.id === 'nextTestDriveDate'" [title]="getFormattedDate(element1[innerColumn.id])">{{getFormattedDate(element1[innerColumn.id])}}</span>
                      <span *ngIf="innerColumn.id === 'status'">
                        <span *ngIf="element1[innerColumn.id] && !element1.expiredAt" class="status online"></span><span
                          *ngIf="element1[innerColumn.id] && !element1.expiredAt" [title]="'servicePersonnel.online' | translate">{{ 'servicePersonnel.online' | translate}}</span>
                        <span *ngIf="!element1[innerColumn.id] && !element1.expiredAt" class="status offline"> </span><span
                          *ngIf="!element1[innerColumn.id] && !element1.expiredAt" [title]="'vehicleManagement.offline' | translate">{{ 'vehicleManagement.offline' | translate}}</span>
                          <span *ngIf="element1.expiredAt && element1.nextTestDriveDate" class="status deletePending"></span>
                    <span *ngIf="element1.expiredAt && element1.nextTestDriveDate" class="text" [title]="'vehicleManagement.deletePending' | translate">{{'vehicleManagement.deletePending' | translate}}</span>
                      </span>

                      <span class="copy-vin" *ngIf="innerColumn.id === 'vin'">
                        <div [title]="element1[innerColumn.id]" style="width: 70%;">...{{element1[innerColumn.id].slice(-7)}}</div>
                        <button mat-icon-button aria-label="copy icon" class="copy-icon"
                          matTooltipPosition="above" [matTooltip]="'vehicleManagement.copyVin' | translate" (click)="onCopyDetails(element1.vin)">
                          <mat-icon>
                            <span class="material-icons">content_copy</span>
                          </mat-icon>
                        </button>
                      </span>
                      
                      <span class="licensePlate" *ngIf="innerColumn.id === 'licensePlate'">
                        <span [title]="element1[innerColumn.id]">{{viewMode === source.ME ? element1[innerColumn.id] : element1['stockNo'] }}</span>
                        <div class="licensePlate-right" *ngIf="innerColumn.id === 'licensePlate' && viewMode === source.ME" (click) ="mouseEnter(element1) "
                        matTooltipPosition="above" [matTooltip]="'testDrive.editStockNo' | translate">
                          <asp-icon color="selectedVehicle?.vin === element1.vin ? 
                          'white' : 'rgba(14,19,25,0.8)'" height='0.8rem' name="ic-20-utility-edit.svg" width="0.8rem" style="padding-right: 0.5rem"></asp-icon>
                        </div>
                      </span>

                      
                    </td>
                  </ng-container>
                  <tr mat-row *matRowDef="let row; columns: columnsToDisplayWithExpand;" 
                  class="inner-tbl-row" (click)=" vehicleSelected(row)"
                  [class.demo-row-is-clicked]="selectedVehicle?.vin === row.vin"
                  [class.has-expanded-row]="expandedElements?.length > 0 || ( allRowsExpanded && isExpandedViewAllowed) "
                  [class.no-expanded-row]="!expandedElements?.length && (!allRowsExpanded || (allRowsExpanded && !isExpandedViewAllowed))"></tr>
                </table>
              </div>
            </div>
          </td>
        </ng-container>
        
        <ng-container matColumnDef="{{column.id}}" *ngFor="let column of initColumnsForFilter">
          <div>
            <th mat-header-cell *matHeaderCellDef scope="col">

              <form [formGroup]="searchForm">

                <div *ngIf="column.id === 'expandFilter' " >
                  <mat-icon style="height: 15px;">search</mat-icon>
                </div>

                <div *ngIf="column.id !== 'expandFilter' && column.id!== 'statusFilter' && 
                    column.id !== 'healthStatusFilter' && column.id !== 'nextTestDriveDateFilter' && column.id !== 'sourceSystemFilter' ">
                  <input matInput [formControlName]="column.id" #searchValue autocomplete="off"
                    [ngClass]=" searchValue.value ? 'opacity-1' : 'opacity-0'" placeholder="{{column.display | translate}}"
                    (keyup.enter)="addSearchField(column.id, searchValue.value)" 
                    (keydown.tab)="addSearchField(column.id, searchValue.value)">
                </div>

                <div *ngIf="column.id === 'nextTestDriveDateFilter'" style="    height: 1.5rem;
                      margin-top: 0.5rem; display: flex;">
                  <input matInput [matDatepicker]="picker" [formControlName]="column.id" #dateValue
                    autocomplete="off" [ngClass]=" dateValue.value ? 'opacity-1' : 'opacity-0'" style="width: 75%"
                    placeholder="{{column.display | translate}}" (dateChange)="addSearchField(column.id, dateValue.value)">
                  <mat-datepicker-toggle class="date-picker" matSuffix [for]="picker" style="margin-top: -10px;">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </div>

                <div *ngIf="column.id === 'statusFilter' " >
                  <mat-select [formControlName]="column.id">
                    <mat-option [value]='option.id' *ngFor="let option of statusOptions"
                      (click)="addSearchField(column.id,option.display)">
                      {{ option.display | translate }}
                    </mat-option>
                  </mat-select>
                </div>

              </form>
            </th>
          </div>
        </ng-container>

        <ng-container matColumnDef="noRecord">
          <td mat-footer-cell *matFooterCellDef [attr.colspan]="columnsToDisplayWithExpand.length" class="text-center">
            <div style="margin-top: 5rem;"><mat-icon class="mat-icon no-record-icon" >info_outline</mat-icon></div>
        <div
          class="no-record-label">{{'vehicleManagement.noMatchFound' | translate}}</div>
          <div  (click)="clearFilters()" class='action enabled no-record-clear-btn'>
            <div class="btnText no-record-clear-btn-text">{{'vehicleManagement.clearFilters' | translate}}</div>
          </div>
        </td>
        </ng-container>

        <ng-container matColumnDef="searchLoader">
          <td mat-footer-cell *matFooterCellDef [attr.colspan]="columnsToDisplayWithExpand.length" class="text-center">
            <div id="search-vehicle-loading">
              <app-loading size="0.8" color="var(--primary-sec-color)" loadingSymbol="dots"
                [text]="'serviceSchedule.loading' | translate">
              </app-loading>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand; sticky: true" 
        [class.no-record-header]="dataSource.data.length === 0"
        [class.has-expanded-row]="expandedElements?.length > 0 || ( allRowsExpanded && isExpandedViewAllowed )"
          [class.no-expanded-row]="!expandedElements?.length && (!allRowsExpanded || (allRowsExpanded && !isExpandedViewAllowed))"></tr>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplayForFilter; sticky: true" class="filter-row"></tr>

        <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;"
        class="example-element-row"
           [class.example-expanded-row]="isExpanded(element.value[0]) === 'expanded'"
          (click)="element.value.length > 1 ? '': vehicleSelected(element.value[0])"
          [class.demo-row-is-clicked]="element.value.length === 1 && selectedVehicle?.vin === element.value[0].vin"
          [class.has-expanded-row]="expandedElements?.length > 0 || ( allRowsExpanded && isExpandedViewAllowed )"
          [class.no-expanded-row]="!expandedElements?.length && (!allRowsExpanded || (allRowsExpanded && !isExpandedViewAllowed))">
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>

        <tr mat-footer-row *matFooterRowDef = "['searchLoader']" class="search-loader" [class.no-row] = "!isSearchLoading"></tr>

        <tr mat-footer-row *matFooterRowDef = "['noRecord']" 
        [ngClass] = "(dataSource.data.length === 0) && (searchValues.length > 0 && !isSearchLoading) ? 'no-record-row' : 'no-row'"></tr>

      </table>
    </div>

      </div>

      <div class="panel-right" [ngClass]="searchValues.length > 0 ? 'withSearch' : ''">
        <div class="disable-layer" *ngIf="!!disableForm"></div>
        <div>
          <div class="title-right" *ngIf="selectedVehicle">
            <form [formGroup]="vehicleForm">
      
              <div class="text">{{ 'servicePersonnel.online' | translate}}</div>
              <div class="switch">
                <app-onofswitch [switchInput]="vehicleForm?.get('status').value"
                  (switchChange)="updateSwitchValues($event)">
                </app-onofswitch>
                <!-- disabled toggle for NVI till status flow changes are done-->
               
              </div>
      
            </form>
          </div>

          <app-fleet-appointment [vehicle]="selectedVehicle" *ngIf="selectedVehicle" [searchValues]="searchValues">
          </app-fleet-appointment>

        </div>
      </div>

    </div>
  </div>
</section>
</div>

<section *ngIf="viewMode === 'Delete Pending'">
  <app-delete-pending></app-delete-pending>
</section>
</section>

<ng-template #loader>
  <div id="loading-spinner">
    <app-loading size="0.5" color="var(--primary-sec-color)"></app-loading>
  </div>
</ng-template>